import React, { useEffect, useState } from "react";
import { Modal, Checkbox } from "antd";
import dineroDisabledMask from "./dineroDisabledMask";
import round2Decimals from "./round2Decimals";

//Misma llave que usa el backend en Utils/abonosComisionBanco.utils.js. Los paquetes que
//vienen de la lista plana vieja del banco no tienen _id, por eso el centinela.
const keyPaqueteComision = (paquete) => (paquete && paquete._id ? String(paquete._id) : "legacy");

const nombreProveedorComision = (banco, proveedorId) => {
  const proveedor = (banco?.proveedoresComisionInfo || []).find(
    (valueProveedor) => valueProveedor._id.toString() === proveedorId.toString()
  );
  if (!proveedor) return "Proveedor";
  return proveedor.persona
    ? proveedor.razonSocial
    : `${proveedor.nombre} ${proveedor.apellidoPaterno || ""} ${proveedor.apellidoMaterno || ""}`.trim();
};

const totalPaquete = (paquete) =>
  round2Decimals((paquete.comisiones || []).reduce((acc, valueComision) => acc + (valueComision.monto || 0), 0));

function ModalComisionesBanco(props) {
  //moneda: abreviacion de la moneda del banco, en la que estan capturados los montos
  const { visible, banco, moneda, onCancel, onOk } = props;
  const paquetes = banco?.paquetesComision || [];
  const sufijoMoneda = moneda ? ` ${moneda}` : "";
  const [seleccionados, setSeleccionados] = useState([]);

  //Al abrirse solo viene marcado el primer paquete, haya uno o varios
  useEffect(() => {
    if (visible) {
      const primerPaquete = (banco?.paquetesComision || [])[0];
      setSeleccionados(primerPaquete ? [keyPaqueteComision(primerPaquete)] : []);
    }
  }, [visible, banco]);

  const onChangePaquete = (llave, checked) => {
    setSeleccionados((prev) => (checked ? [...prev, llave] : prev.filter((valueLlave) => valueLlave !== llave)));
  };

  const totalAplicar = round2Decimals(
    paquetes
      .filter((paquete) => seleccionados.includes(keyPaqueteComision(paquete)))
      .reduce((acc, paquete) => acc + totalPaquete(paquete), 0)
  );

  return (
    <Modal
      title="Comisión bancaria por transferencia"
      visible={visible}
      onCancel={onCancel}
      onOk={() => onOk(seleccionados)}
      okText="Continuar"
      cancelText="Cancelar"
    >
      <p>Este banco tiene configurados los siguientes paquetes de comisión. Elige cuáles aplicar a este pago:</p>
      {paquetes.map((paquete) => {
        const llave = keyPaqueteComision(paquete);
        return (
          <div key={llave} style={{ marginBottom: 12 }}>
            <Checkbox
              checked={seleccionados.includes(llave)}
              onChange={(e) => onChangePaquete(llave, e.target.checked)}
            >
              <strong>{paquete.nombre}</strong> — {dineroDisabledMask(totalPaquete(paquete))}{sufijoMoneda}
            </Checkbox>
            <ul style={{ margin: "4px 0 0 24px", paddingLeft: 16 }}>
              {(paquete.comisiones || []).map((valueComision, index) => (
                <li key={index} style={{ fontSize: 12, color: "#888" }}>
                  {nombreProveedorComision(banco, valueComision.proveedorId)} — {dineroDisabledMask(valueComision.monto)}{sufijoMoneda}
                  {valueComision.concepto ? ` (${valueComision.concepto})` : ""}
                </li>
              ))}
            </ul>
          </div>
        );
      })}
      <p>
        Total a aplicar: <strong>{dineroDisabledMask(totalAplicar)}{sufijoMoneda}</strong>
      </p>
    </Modal>
  );
}

export default ModalComisionesBanco;
